import { render, staticRenderFns } from "./UserColorsResetAllChangesModal.vue?vue&type=template&id=840d9194&"
import script from "./UserColorsResetAllChangesModal.vue?vue&type=script&lang=js&"
export * from "./UserColorsResetAllChangesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports